// extracted by mini-css-extract-plugin
export var clauseRow = "_dg-6";
export var emptyState = "_dg-d";
export var filterContent = "_dg-a";
export var filterGroup = "_dg-1";
export var filterGroupContainer = "_dg-0";
export var nestedGroup = "_dg-2";
export var nestedGroupContent = "_dg-b";
export var nestedGroupDepth1 = "_dg-3";
export var nestedGroupDepth2 = "_dg-4";
export var nestedGroupDepth3 = "_dg-5";
export var nestedGroupEmpty = "_dg-c";
export var operatorAnd = "_dg-8";
export var operatorOr = "_dg-9";
export var operatorToggle = "_dg-7";
export var removeGroupButton = "_dg-e";